import {keys, owns} from '../lang/object';
import {createStorage} from './base';

const
    createMemoryStorage = name => {
        let names = null;
        const
            store = {},
            getItem = key => (
                owns(store, key) ?
                    store[key] :
                    null),
            setItem = (key, value) => {
                if (!owns(store, key)) {
                    names = null;
                    storage.length += 1;
                }
                store[key] = value;
            },
            removeItem = key => {
                if (owns(store, key)) {
                    names = null;
                    delete store[key];
                    storage.length -= 1;
                }
            },
            key = index => {
                if (!names) {
                    names = keys(store);
                }
                return (
                    index < names.length ?
                        names[index] :
                        null);
            },
            storage = {
                getItem,
                setItem,
                removeItem,
                key,
                length: 0
            };

        return createStorage(name, storage);
    };

export {
    createMemoryStorage
};
